import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'material-ui/styles/withStyles';
import LanguageSelect from '../../../components/main/collections/language-select/index';
import List from '../../../components/main/collections/list/index';
import styles from './styles';

const CollectionsPage = props => (
	<React.Fragment>
		<LanguageSelect classes={{container: props.classes.languageSelect}}/>
		<List handleShowFiles={props.handleShowFiles}/>
	</React.Fragment>
);

CollectionsPage.propTypes = {
	handleShowFiles: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(CollectionsPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/collections/collections.jsx